import * as request from '../api-request'

export const getNames = async (data = {}) => {
  return request.toJSON('GET', 'common/library/names', {})
}
